import { asyncRetryWithExponentialBackOff } from '@onyx/utils/promises';

import type { HandleFetchReturn } from './handle-fetch';
import { handleFetch } from './handle-fetch';

type ShouldRetry = (
  result: Awaited<HandleFetchReturn>,
  attempt: number
) => boolean;

export type RetryOptions = {
  maxRetries?: number;
  delayFactorInMS?: number;
  shouldRetry?: ShouldRetry;
};

type FetchOptions = {
  createInit?: () => RequestInit | undefined;
  init?: RequestInit;
  retryOptions?: RetryOptions;
};

export const handleFetchWithRetry = (
  input: string | URL | Request,
  options: FetchOptions = {}
): HandleFetchReturn => {
  const {
    createInit,
    init,
    retryOptions: {
      maxRetries = 3,
      delayFactorInMS = 300,
      shouldRetry: baseShouldRetry = undefined,
    } = {},
  } = options;

  return asyncRetryWithExponentialBackOff(
    () => handleFetch(input, createInit?.() ?? init),
    {
      shouldRetry: (resolvedValue, attemptNumber) => {
        if (baseShouldRetry !== undefined) {
          return baseShouldRetry(resolvedValue, attemptNumber);
        }
        const [, result] = resolvedValue;
        return !result;
      },
      maxRetries,
      delayFactorInMS,
    }
  ).catch((e) => {
    return e as HandleFetchReturn;
  });
};
